import React, { useState } from 'react';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import { Row } from 'styled/alignment/Row';
import HomeWrapper from './HomeWrapper';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';
import MainV2 from 'modules/home/MainV2';
import HomeHeader from 'components/commons/HomeHeader';

export default function Home() {
    const [mobileView, setMobileView] = useState('list');

    return (
        <HomeWrapper>
            <HomeHeader mobileView={mobileView} />
            <ContentHeader>
                <DashHeaderActions />
            </ContentHeader>
            <MainV2 mobileView={mobileView} setMobileView={setMobileView} />
        </HomeWrapper>
    );
}

const ContentHeader = styled(Row)`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
